import $ from 'jquery';

export function onSelectWarningLang(selectEl: HTMLSelectElement) {
    const selectedLandg = selectEl.value;
    let warningEl: HTMLElement = selectEl;

    while (warningEl.parentElement != null && !warningEl.className.includes("warning-wrapper")) {
        warningEl = warningEl.parentElement;
    }

    changeWarningLang(warningEl, selectedLandg)
}

export function changeWarningLang(warningEl: HTMLElement, selectedLang: string) {
    const toHide = warningEl.querySelectorAll<HTMLElement>(
        "*[lang]:not([lang='"+selectedLang+"'])"
    )

    toHide.forEach((el) => {
        el.style["display"] = "none";
    })
   
    const toShow = warningEl.querySelectorAll<HTMLElement>(
        "*[lang='"+selectedLang+"']"
    )

    toShow.forEach((el) => {
        el.style["display"] = "inherit";
    })
}

$(function () {
    $('.warning-wrapper').each((_i, el) => {
        const defaultLang = el.getAttribute('defaultLang');
        if (defaultLang != null) { changeWarningLang(el, defaultLang); }
        return;
    })

    $('.warning-wrapper .source-lang > select').on("change", (event) => {
        if (!(event.target instanceof HTMLSelectElement)) return;
        onSelectWarningLang(event.target);
    })
})